import React from 'react';
import { RendererContext } from '../../context';

export const useIsMacro = (): boolean => {
	const { extensionType } = React.useContext(RendererContext);
	return extensionType === 'xen:macro';
};

export const useIsBylineItem = (): boolean => {
	const { extensionType } = React.useContext(RendererContext);
	return extensionType === 'confluence:contentBylineItem';
};
